let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("qi4NO")).then(() => parcelRequire('kX0us'));